import { IonIcon } from '@ionic/react';
import { alertCircleOutline, sparklesOutline } from 'ionicons/icons';
import React from 'react';
import {
  AGENT_PROMPT_SUGGESTIONS,
  AgentPromptSuggestion,
} from './AgentChat.types';
import { ChatEngine, missingChatKeyHint } from './agentEngine';

const STARTERS = AGENT_PROMPT_SUGGESTIONS.slice(0, 4);

export const AgentChatEmpty: React.FC<{
  configured: boolean | null;
  engine?: ChatEngine;
  onPrompt: (prompt: string) => void;
}> = ({ configured, engine = 'direct', onPrompt }) => (
  <div className="agent-empty">
    <IonIcon icon={sparklesOutline} className="agent-empty-icon" />
    <h4>Ask about your library</h4>
    <p>
      Find duplicates, build a crate, or audit what is in your crates — the
      assistant searches your library and connected sources.
    </p>
    {configured === false && (
      <p className="agent-thread-empty-warning">
        <IonIcon icon={alertCircleOutline} />
        {missingChatKeyHint(engine)}
      </p>
    )}
    <div className="agent-empty-prompts">
      {STARTERS.map((suggestion: AgentPromptSuggestion) => (
        <button
          key={suggestion.label}
          type="button"
          className="agent-empty-prompt"
          onClick={() => onPrompt(suggestion.prompt)}
        >
          <span>{suggestion.label}</span>
          <span aria-hidden="true">→</span>
        </button>
      ))}
    </div>
  </div>
);

export default AgentChatEmpty;
